<template>
  <span @mouseenter="mostrarCompletoSiCortado">
    <span
      v-for="(parte, indice) in partes"
      :key="indice"
      :class="{ 'fw-semibold': parte.coincide }"
    >{{ parte.texto }}</span>
  </span>
</template>

<script>
export default {
  props: {
    texto: { type: [String, Number], default: "" },
    busqueda: { type: [String, Number], default: "" },
  },
  computed: {
    partes() {
      const texto = this.texto == null ? "" : String(this.texto);
      const busqueda = this.busqueda == null ? "" : String(this.busqueda).trim();
      if (!busqueda) return [{ texto, coincide: false }];

      // La búsqueda es literal: los símbolos escritos no son una expresión regular.
      const literal = busqueda.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const patron = new RegExp(literal, "gi");
      const partes = [];
      let posicion = 0;
      let coincidencia;
      while ((coincidencia = patron.exec(texto)) !== null) {
        if (coincidencia.index > posicion) {
          partes.push({ texto: texto.slice(posicion, coincidencia.index), coincide: false });
        }
        partes.push({ texto: coincidencia[0], coincide: true });
        posicion = coincidencia.index + coincidencia[0].length;
      }
      if (posicion < texto.length || !partes.length) {
        partes.push({ texto: texto.slice(posicion), coincide: false });
      }
      return partes;
    },
  },
  methods: {
    // Las sugerencias largas se cortan con "…": solo entonces se ve el texto completo al pasar el ratón.
    mostrarCompletoSiCortado() {
      const fila = this.$el.closest("li") || this.$el;
      if (fila.scrollWidth > fila.clientWidth) fila.setAttribute("title", String(this.texto));
      else fila.removeAttribute("title");
    },
  },
};
</script>
